"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromptCheckCircleFill = void 0;
var tslib_1 = require("tslib");
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
var react_1 = tslib_1.__importStar(require("react"));
var BaseIcon_1 = tslib_1.__importDefault(require("@ad/anq-iconfont.macro/lib/components/BaseIcon"));
var PromptCheckCircleFill = /** @class */ (function (_super) {
    tslib_1.__extends(PromptCheckCircleFill, _super);
    function PromptCheckCircleFill() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.iconSvg = function () { return (react_1.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 1024 1024", version: "1.1", fill: "currentColor", "aria-hidden": "true", focusable: "false" },
            react_1.default.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m193.5 301.7l-210.6 292c-12.7 17.7-39 17.7-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" }))); };
        return _this;
    }
    PromptCheckCircleFill.prototype.render = function () {
        return react_1.default.createElement(BaseIcon_1.default, tslib_1.__assign({ component: this.iconSvg }, this.props));
    };
    return PromptCheckCircleFill;
}(react_1.Component));
exports.PromptCheckCircleFill = PromptCheckCircleFill;
//# sourceMappingURL=PromptCheckCircleFill.js.map